import { getDigits } from '@/elements/utils.js';
const DIRECTIVES = ['onlyNumbers', 'cardNumber', 'quotaMB', 'quotaGB'];
export const qxInput = {
  updated: function (el, binding, vnode) {
    // no directive is set
    if (!binding.value || !DIRECTIVES.includes(binding.value)) {
      return;
    }
    let match = el.value.match(/\d/g);

    // only numbers
    if (binding.value === 'onlyNumbers') {
      const newValue = match?.join('') || '';
      if (newValue !== el.value) {
        el.value = newValue;
        dispatchEvent(el);
      }
      return;
    }

    // card number
    if (binding.value === 'cardNumber') {
      const newValue =
        match
          ?.join('')
          .match(/.{1,4}/g)
          .join(' ') || '';
      if (newValue !== el.value) {
        el.value = newValue;
        dispatchEvent(el);
      }
      return;
    }

    if (binding.value === 'quotaGB') {
      const innerValue = el.value;
      let value;
      // This condition to check for symbols and more than 1 dots
      if (innerValue.indexOf('.') > 0) {
        value =
          innerValue.indexOf('.') === innerValue.lastIndexOf('.')
            ? innerValue.replace(/[^\d.-]/g, '')
            : innerValue.replace(/[^\d.-]/g, '').slice(0, -1);
      } else {
        // to prevent input numbers starting from 0
        value = `${Number.parseFloat(innerValue)}`;
      }
      if (value !== 0) {
        // value is NaN when erasing the whole field
        value = isNaN(value) ? '0' : getDigits(value, false);
      }
      if (value !== el.value) {
        el.value = value;
        dispatchEvent(el);
        return;
      }
    }

    if (binding.value === 'quotaMB') {
      let newValue = (Boolean(match) && match.join('')) || '';
      newValue = `${Number.parseFloat(newValue)}`;
      if (isNaN(newValue)) {
        newValue = 0;
      }
      if (newValue !== el.value) {
        el.value = newValue;
        dispatchEvent(el);
      }
      return;
    }
  },
};

export const onlyNumbers = {
  updated: function (el, binding, vnode) {
    // check if visibility prop was passed as false. in other cases apply directive
    if (binding.value === false) {
      return;
    }
    const match = el.value.match(/\d/g),
      newValue = (Boolean(match) && match.join('')) || '';
    if (newValue !== el.value) {
      el.value = newValue;
      dispatchEvent(el);
    }
  },
};

export const cardNumber = {
  updated: function (el, binding, vnode) {
    const match = el.value.match(/\d/g);
    el.value =
      (Boolean(match) &&
        match
          .join('')
          .match(/.{1,4}/g)
          .join(' ')) ||
      '';
    dispatchEvent(el);
  },
};

export const expDate = {
  updated: function (el) {
    const match = el.value.match(/\d/g);
    let newValue = '';
    if (match !== null) {
      const valueMatch = [...match];
      const t = valueMatch.splice(0, 2);
      newValue = t.join('');
    }
    if (newValue !== el.value) {
      el.value = newValue;
      dispatchEvent(el);
    }
  },
};

const dispatchEvent = (el) => {
  let event;
  if (typeof Event === 'function') {
    event = new Event('update:modelValue');
  }
  el.dispatchEvent(event);
};
